import { components, OptionProps } from "react-select";
import {
  IconButton,
  IconButtonSize,
  IconButtonVariant,
  BaseOption
} from "shared/components";
import { Trash04 } from "untitledui-js-base";

type Props = OptionProps & {
  onRequestDelete: (payload: { label: string; slug: string }) => void;
  deleting?: boolean;
};

export const CustomAmenityOption = (props: Props) => {
  const { data } = props as unknown as { data: BaseOption };
  const isCreateOption = Boolean(
    (data as unknown as { __isNew__?: boolean }).__isNew__
  );

  return (
    <components.Option {...props}>
      <div className="flex items-center justify-between gap-2 min-h-10">
        <p className="line-clamp-2 flex-1 min-w-0 break-words">{data.label}</p>
        {isCreateOption ? null : (
          <IconButton
            borderLess
            Icon={Trash04}
            size={IconButtonSize.SM}
            variant={IconButtonVariant.BASE}
            className="shrink-0 !stroke-content-100"
            loading={props.deleting}
            onClick={(e) => {
              e.stopPropagation();
              props.onRequestDelete({
                label: String(data.label),
                slug: String((data as BaseOption).id || "")
              });
            }}
          />
        )}
      </div>
    </components.Option>
  );
};
